import React, { useContext } from 'react';

import QuoterContext from '../context/QuoterContext';

const QuoterProgress = () => {
  const { quoterContextValues } = useContext(QuoterContext);

  const quoterSteps = [];

  if (quoterContextValues.ids.idPaso !== 6) {
    for (let i = 1; i <= 5; i += 1) {
      let stepClasses = 'step';
      if (i === quoterContextValues.ids.idPaso) {
        stepClasses += ' -current';
      } else if (i < quoterContextValues.ids.idPaso) {
        stepClasses += ' -previous';
      }

      quoterSteps.push((
        <div className={stepClasses} key={`step-number-${i}`}>
          <div className="checkmark" />
          <div className="number">{i}</div>
        </div>
      ));
    }
  }

  return (
    quoterContextValues.ids.idPaso !== 6
      ? (
        <div className="quoter-progress">
          <div className="progress-line" />
          <div className="steps">
            {quoterSteps}
          </div>
        </div>
      )
      : (
        <div className="quoter-progress">
          <div className="steps -result">
            <div className="step -result" key="step-result">
              <div className="checkmark" />
              <div className="text">Listo</div>
            </div>
          </div>
        </div>
      )
  );
};

export default QuoterProgress;
